import Toiyibun from './toiyibun';

export { Toiyibun };
export default { Toiyibun };
